// extracted by css-extract-rspack-plugin
export default {"cls1":"Loading-cls1_vIt","cls2":"Loading-cls2_A0c Loading-cls1_vIt"};